import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { authToken } from 'config/axios';
import { catchAsync } from 'helpers';

export const refreshUser = createAsyncThunk(
  'auth/current',
  catchAsync(async (_, thunkAPI) => {
    const { token } = thunkAPI.getState().auth;
    if (!token) return thunkAPI.rejectWithValue('No valid token');
    authToken.set(token);

    const res = await axios.get('/auth/current');
    return res.data;
  })
);
